export const StoritveOpisFormat = {
  methods: {
    OlepsajOpiseStoritev (seznamMoznihStoritev) {
      let noviDiv = document.createElement('div')
      let img = document.createElement('img')
      noviDiv.append(img)
      const srcLink = '/static/img/kljukica2.svg'
      img.setAttribute('src', srcLink)
      img.setAttribute('width', '12px')
      img.setAttribute('height', '9.2px')
      img.setAttribute('style', 'vertical-align: middle; margin-right: 8px;')
      for (let i = 0; i < seznamMoznihStoritev.length; i++) {
        let opisFormatiran = ''
        let seznamAlinej = seznamMoznihStoritev[i].opis.split('\n')
        for (let i = 0; i < seznamAlinej.length; i++) {
          let opisVrstica = seznamAlinej[i].trim()
          let vrstica = ''
          let vsebujeMinus = opisVrstica.charAt(0) === '-'
          if (vsebujeMinus || opisVrstica.includes('Mbps')) {
            if (vsebujeMinus) opisVrstica = opisVrstica.substring(1)
            vrstica = '<table border="0" cellpadding="0" cellspacing="0" ' +
              ' style="margin:0 10px 13px 0; width:100%;display:inline-block">' +
              '<tr><td valign="top">' + noviDiv.innerHTML + '</td>' +
              '<td style="width:100%">' + opisVrstica.trim() + '</td></tr></table>'
          } else {
            vrstica = opisVrstica.trim() + '<br/>'
          }
          opisFormatiran += vrstica + '\n'
        }
        seznamMoznihStoritev[i].opis = opisFormatiran
      }
      return seznamMoznihStoritev
    },
    PridobiSeznamOpisov (seznamMoznihStoritev) {
      for (let i = 0; i < seznamMoznihStoritev.length; i++) {
        let opisFormatiran = []
        let opisi = seznamMoznihStoritev[i].opis.split('\n')
        opisi.forEach(function (prop) {
          opisFormatiran.push(prop)
        })
        seznamMoznihStoritev[i].opis = opisFormatiran
      }
      return seznamMoznihStoritev
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StoritveOpisFormat.js